import { decodeBase64 } from '../../components/utils';
import { Nullable } from '../../core';

/** The server-minted fields a coordinator needs off a completed upload. */
export type UploadTokenData = {
  id?: string;
  recordingLocation?: string;
};

/**
 * Reads an upload token. The token is base64 handed back by the browser, so a truncated or
 * corrupted one is an ordinary failed upload — never an exception. Both `atob` and `JSON.parse`
 * throw on malformed input, and the coordinators that read tokens are not awaited by their callers,
 * so a throw here would surface only as an unhandled rejection with the upload stuck looking busy.
 */
export function decodeUploadToken(token: Nullable<string>): UploadTokenData | null {
  if (!token) return null;

  try {
    return decodeBase64(token, true) as UploadTokenData | null;
  } catch {
    return null;
  }
}

export function jobIdFromToken(token: Nullable<string>): string | null {
  return decodeUploadToken(token)?.id || null;
}

export function recordingLocationFromToken(token: Nullable<string>): string | null {
  return decodeUploadToken(token)?.recordingLocation || null;
}
